// Helpers de formatage partagés par les modèles de facture (aperçu).

export const fmtMoney = (amount, currency = 'USD') => {
  const n = Number(amount) || 0;
  try {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(n);
  } catch {
    return `${n.toFixed(2)} ${currency}`;
  }
};

export const fmtDate = (date) => {
  if (!date) return '—';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

// taxRate peut arriver soit en fraction (0.2) soit en % (20) selon la source.
// On normalise en % pour l'affichage de l'étiquette "TVA (x%)".
export const taxRateToPercent = (rate) => {
  const r = Number(rate) || 0;
  return r > 0 && r <= 1 ? Math.round(r * 1000) / 10 : r;
};

// Construit la ligne d'item normalisée pour l'aperçu, total recalculé.
export const previewItems = (items = []) =>
  (Array.isArray(items) ? items : []).map((it) => {
    const quantity = Number(it.quantity) || 0;
    const unitPrice = Number(it.unitPrice != null ? it.unitPrice : it.price) || 0;
    return {
      productId: it.productId || '',
      description: it.description || it.productName || it.name || '',
      quantity,
      unitPrice,
      total: it.total != null ? Number(it.total) : quantity * unitPrice,
    };
  });
